import React, {useState} from 'react';
import AnalyticsNavigationTabs from '../../../../../uiToolkit/Analytics/AnalyticsNavigationTabs';
import {courseLevelAnalyticsTabs} from '../../conf';
import GradesTable from '../../../components/GradesTable';
import AnalyticsEmptyState from '../../../../../uiToolkit/Analytics/AnalyticsEmptyState';
import './styles.css';
import {analyticsText} from '../../../analyticsText';
import TableLegend from '../../../components/TableLegend';
import {AnalyticsTableSkeleton} from '../../../components/AnalyticsSkeletons';
import {MappedGradebook} from '../mappers';

interface Props {
  onExport: () => void;
  organizationId: string;
  courseId: string;
  // True until the gradebook request resolves; drives the widget preloader.
  gradebookLoading: boolean;
  gradebook?: MappedGradebook;
}

const CourseAnalyticsOverviewUI = React.memo(
  ({
    onExport,
    organizationId,
    courseId,
    gradebookLoading,
    gradebook,
  }: Props) => {
    const [search, setSearch] = useState('');
    const [orderAsc, setOrderAsc] = useState(false);

    const getLearnerRecords = () => {
      let result = [];
      if (orderAsc) {
        result = gradebook!.learnerRecords.sort((x, y) =>
          x.name > y.name ? 1 : -1,
        );
      } else {
        result = gradebook!.learnerRecords!.sort((x, y) =>
          x.name < y.name ? 1 : -1,
        );
      }
      if (search) {
        result = result.filter(x =>
          x.name.toLowerCase().includes(search.toLowerCase()),
        );
      }
      return result;
    };

    return (
      <div>
        <AnalyticsNavigationTabs
          onExport={onExport}
          search={search}
          setSearch={setSearch}
          tabs={courseLevelAnalyticsTabs(organizationId, courseId)}
        />
        <div className="PassingScoreAndLegend">
          {gradebook?.passingScore ? (
            <div className="PassingScoreContainer">
              <span className="icon-icon_score"></span>
              <span className="InfoText">{analyticsText.passingScore}</span>
              <span className="ScoreText">{gradebook?.passingScore}</span>
            </div>
          ) : (
            <div />
          )}
          <TableLegend hideNotStarted />
        </div>
        {gradebookLoading ? (
          <AnalyticsTableSkeleton />
        ) : gradebook ? (
          <div className="GradesTableContainer">
            <GradesTable
              headerItems={gradebook!.headerItems}
              avgScores={gradebook.avgScores}
              orderAsc={orderAsc}
              setOrderAsc={setOrderAsc}
              learnerRecords={getLearnerRecords()}
            />
          </div>
        ) : (
          <AnalyticsEmptyState />
        )}
      </div>
    );
  },
);

export default CourseAnalyticsOverviewUI;
